import React, { useEffect, useState } from 'react';

// Utils
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../store/AppContext';

// Components
import LoginForm from '../../components/auth/LoginForm/LoginForm';

function Login() {
  const navigate = useNavigate();

  const [mounted, setMounted] = useState(false);
  const [{ user }] = useAppContext();

  useEffect(() => { setMounted(true); }, []);

  useEffect(() => {
    if (mounted && user) navigate('/');
  }, [mounted]);

  return mounted && !user ? (
    <div className="d-flex a-center j-center full-view-height mobile-a-stretch">
      <LoginForm />
    </div>
  ) : null;
}

Login.propTypes = {};

export default Login;
